<div class="popup-container">
    <header>
      <div class="close_button" (click)="close()">x</div>
      <div class="header d-block roboto-medium">
        <label class="ms-3 mt-3 mb-3">Upload Delayed Dispatch</label>
        
        <!-- <app-file-export-renderer style="display: inline-block;float:right; margin-top:10px; margin-right:20px" class="bg-dark text-white"></app-file-export-renderer> -->
      </div>
    </header>
    <div class="main">
      <div
          class="px-3"
          *ngIf="successMessage != null"
          class="alert alert-success alert-dismissible fade show p-2 ms-4 me-4"
          role="alert"
        >
          <button
            type="button"
            class="btn-close"
            (click)="closeNotif()"
            data-bs-dismiss="alert"
            aria-label="close"
          ></button>
          <strong>{{ successMessage }}</strong>
        </div>
    <div
          class="px-3"
          *ngIf="errorMessage != null"
          class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4"
          role="alert"
        >
          <button
            type="button"
            class="btn-close"
            (click)="closeNotif()"
            data-bs-dismiss="alert"
            aria-label="close"
          ></button>
          <strong>{{ errorMessage }}</strong>
        </div>
      
    
    <label class="catlabel col-4">Uploaded Documents: </label>
    <div class="divInline">
      <!-- <div class="col-4"></div> -->
      <!-- <div *ngFor="let doc of fetchedDocs">
        <div class="col-4"></div>
        <a (click)="download(doc.imageID,doc.fileName)" class="col-4 docList">{{doc.fileName}}</a>
        <img (click)="delete(doc.imageID)" class="dltImg" src="assets/images/icons8-delete-24.png"><br>
      </div> -->
      
    <!-- <ng-template #elseBlock><p class="col-4 docList">No file choosen</p></ng-template> -->
    </div><br>
    </div>
    
    
    <div class="footer d-flex justify-content-between align-items-center fixed-bottom mt-2 py-2 ps-4">
      
      <div class="d-flex">
        <input type="file" style="display: none;" multiple="true" (change)="onFileSelected($event)" accept=".xlsx,.pdf,.jpeg,.docx,.jpg,.svg,.png,.doc,.xls" #uploadDoc>
        <!-- <input type="file" style="display: none;" multiple="true" (change)="newonFileSelected($event)" accept=".xlsx,.pdf,.jpeg,.docx,.jpg,.svg,.png,.doc,.xls" #uploadDoc> -->

        <button (click)="uploadDoc.value='';uploadDoc.click()" class="submit black-button me-3 roboto-medium" >Upload Document</button>
        <!-- <button  class="submit black-button me-3 roboto-medium" >Download Document</button> -->
        <button  (click)="close()" class="cancel me-3 roboto-bold"> CANCEL </button>
        
      </div>
    
    </div>
    
  </div>
  
  